var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwoStepIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 75,
  height: 75,
  fill: "none",
  viewBox: "0 0 75 75",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M70.25 29.085V11.243c0-1.726-1.4-3.125-3.125-3.125H7.88a3.125 3.125 0 0 0-3.125 3.125v19.642c0 1.726 1.399 3.125 3.125 3.125h23.77"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeWidth: 4,
  d: "M53.302 66.882a16.943 16.943 0 1 0 0-33.887 16.943 16.943 0 0 0 0 33.887Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4,
  d: "M53.302 42.273v7.532l4.958 4.958"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3.125,
  d: "M17.317 24.185a3.126 3.126 0 1 0 0-6.253 3.126 3.126 0 0 0 0 6.253M29.81 24.185a3.126 3.126 0 1 0 0-6.253 3.126 3.126 0 0 0 0 6.253M42.31 24.185a3.126 3.126 0 1 0 0-6.253 3.126 3.126 0 0 0 0 6.253"
})));
export { SvgTwoStepIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/twoStepIcon.svg";